const carouselItems = [
  {
    title: '科幻周：探索未知宇宙',
    desc: '精选全球顶级科幻大片，从太空史诗到AI觉醒，4K蓝光画质带您穿越星际，感受视觉奇观的震撼冲击。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20space%20scene%20with%20colorful%20nebula%20and%20distant%20planets%2C%20epic%20scale%2C%20dramatic%20cosmic%20lighting%2C%20professional%20cinematography%2C%20no%20text%2C%20atmospheric%20and%20immersive&width=1200&height=600&seq=carousel-01-mv&orientation=landscape',
    tag: '热门专题',
  },
  {
    title: '韩剧热播：高分必追合集',
    desc: '2024-2025年度最值得追的高分韩剧大合集，爱情、悬疑、职场、古装全类型覆盖，高清同步更新中。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20romantic%20Korean%20drama%20style%20cinematic%20scene%20with%20cherry%20blossoms%20and%20soft%20sunlight%2C%20dreamy%20atmosphere%2C%20professional%20cinematography%2C%20no%20text%2C%20emotional%20and%20beautiful&width=1200&height=600&seq=carousel-02-mv&orientation=landscape',
    tag: '追剧必备',
  },
  {
    title: '纪录片盛宴：真实的力量',
    desc: 'BBC、国家地理、Discovery顶级纪录片汇聚，4K超清呈现地球奇观、人文历史和科技前沿的震撼影像。',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20style%20scene%20with%20majestic%20mountains%20and%20wildlife%2C%20golden%20hour%20lighting%2C%20epic%20landscape%2C%20professional%20photography%2C%20no%20text%2C%20breathtaking%20vista&width=1200&height=600&seq=carousel-03-mv&orientation=landscape',
    tag: '4K纪录',
  },
  {
    title: '国产佳片：口碑之作精选',
    desc: '近年最受好评的国产电影电视剧一网打尽，从古装权谋到都市情感，超清蓝光画质重温经典与新锐。',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20Chinese%20cinema%20style%20scene%20with%20ink%20wash%20painting%20aesthetic%2C%20misty%20mountains%2C%20elegant%20composition%2C%20cultural%20atmosphere%2C%20no%20text%2C%20poetic%20and%20refined&width=1200&height=600&seq=carousel-04-mv&orientation=landscape',
    tag: '口碑推荐',
  },
  {
    title: '动漫世界：二次元狂欢',
    desc: '热门新番、经典老番、剧场版动画一应俱全，超清画质带来最纯粹的动漫观赏体验，每天都有新发现。',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20fantasy%20world%20with%20colorful%20skies%20and%20floating%20islands%2C%20dreamy%20atmosphere%2C%20beautiful%20illustration%2C%20no%20text%2C%20whimsical%20and%20creative&width=1200&height=600&seq=carousel-05-mv&orientation=landscape',
    tag: '动漫专场',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">焦点专题</h2>
          <p className="mt-3 text-sm text-foreground-500">精选内容专题，发现更多精彩影视</p>
        </div>
        <div className="flex flex-col gap-5">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="relative rounded-2xl overflow-hidden bg-background-200 cursor-pointer group min-h-[200px] md:min-h-[240px]"
            >
              <img
                src={item.image}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-black/20"></div>
              <div className="relative z-10 flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-8 p-6 md:p-10 h-full">
                <div className="flex-shrink-0">
                  <span className="px-3 py-1.5 text-xs font-semibold bg-primary-500 text-white rounded-lg whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="flex-1">
                  <h3 className="text-lg md:text-xl font-heading text-white">{item.title}</h3>
                  <p className="mt-2 text-sm text-foreground-200/80 leading-relaxed max-w-[600px]">{item.desc}</p>
                </div>
                <div className="flex-shrink-0">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/20 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-arrow-right-line text-white"></i>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}